const consts = {};

/**
 * Client type.
 */
consts.TYPE = {
    SALVUS: 0,
    HOMECARE: 1,
    HOSPITAL: 2,
};

/**
 * Client status.
 */
consts.STATUS = {
    NEW: 0,
    ENABLED: 1,
    DISABLED: 2,
};

module.exports = consts;
